export default __webpack_public_path__ + "static/media/triggeractionbgcolor.bfdd7733.png";